/**
 * @file  PhoneLink/index.tsx
 * @description  creates a phone link
 *
 * @author dlima (dlima-electron)
 *
 */
import React from 'react';
import * as S from './styles';
import { PhoneFilled } from '@ant-design/icons';

const PhoneLink = ({ id, title, phone, className }: S.Props): JSX.Element => {
  return (
    <S.Link
      id={id}
      href={`tel:+1${phone}`}
      key={phone}
      title={phone}
      aria-label={phone}
      className={className}
    >
      {title}{' '}
      <S.Nowrap>
        <PhoneFilled className={className} />{' '}
        {phone && <S.Underline>{phone}</S.Underline>}
      </S.Nowrap>
    </S.Link>
  );
};

export default PhoneLink;
